const TableCellDate = (props: any) => {
  let data = props.data ?? "";
  return (
    <td>
      <span><b>{data}</b></span>
    </td>
  )
}

export default TableCellDate